const logger = require("_js/logger.js");
const ua = require("_js/useragent.js");

const params = {};

const ALLOWED_BETS = [
	1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
	11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
	21, 22, 23, 24, 25, 25, 26, 27, 28, 29, 30,
	31, 32, 32, 33, 34, 35, 36, 37, 38, 39, 40,
	50, 60, 70, 75, 80, 90, 100, 125, 150, 200, 250,
	300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000,
	2500, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 20000, 50000
];
const IGNORE_ALLOWED_BETS_SUPP = [180];
const IGNORE_ALLOWED_BETS_SOURCE = ["gc_*"];
const MAX_COUNT_ALLOWED_BETS = 20;
const USE_NOSLEEP_HACK = ["slot", "egame"];

function init(app, sysParams) {
	const game = {
		supportHtml5: false,
		name: (app.name && app.name[0]) ? app.name[0].en : "",
		type: app.type,
		api: app.api,
		loader: app.loader,
		preview: app.preview,
		position: app.position || 1,
		engine: app.engine,
		source: app.source,
		supp: app.supp,
		is_use_soundjs: Boolean(app.is_use_soundjs),
		disable_fs: Boolean(app.disable_fs), // disable full screen on android
		disable_ios_fs: Boolean(app.disable_ios_fs) // disable full screen on ios
	};

	if (app.html5) {
		game.supportHtml5 = true;
		game.html5Dir = app.html5.app[0] + (app.html5.index_path || "");
		if (app.html5.omit_timestamp) game.html5Dir = app.html5.app[0].split('-')[0] + (app.html5.index_path || "");
		game.html5Loader = app.html5.mainjs;
		game.html5Index = app.html5.index_file || "index.html";
		game.flashvars = app.html5.flashvars || "global"; // "global" -- window.flashvars, "search" -- base64 stringified in search URL
	}

	if (typeof app.load_only !== "undefined") {
		game.load_only = app.load_only;
	}

	game.use_nosleep = USE_NOSLEEP_HACK.includes(app.type);

	for (const k in sysParams) {
		params[k] = sysParams[k];
	}
	params.game_id = sysParams.game;
	params.game = game;
	params.disable_ios_fs = Boolean(params.disable_ios_fs);

	setFlashvars(params);
}

function loadScript(url, callback) {
	return new Promise((resolve, reject) => {
		const head = document.head || document.getElementsByTagName("head")[0];
		const script = document.createElement("script");
		script.src = url;
		script.async = false;
		if (script.addEventListener) {
			script.addEventListener("load", resolve, false);
			script.addEventListener("error", reject, false);
		} else if (script.readyState) { // legacy IE
			script.onreadystatechange = callback;
			script.onerror = reject;
		}
		head.appendChild(script);
	});
}

function addListener(obj, eventName, listener) {
	if (obj.addEventListener) {
		obj.addEventListener(eventName, listener, false);
	} else {
		obj.attachEvent(`on${eventName}`, listener);
	}
}

function parseQueryString(text) {
	const qs = {};
	const uri = text.replace("?", "").split("&");
	for (let i = 0, len = uri.length; i < len; i++) {
		const t = uri[i].split("=");
		if (t.length === 2) {
			qs[decodeURIComponent(t[0])] = decodeURIComponent(t[1]);
		}
	}

	return qs;
}

function isInt(v) {
	return !isNaN(v) && (typeof(v) === "number") && ((v|0) === v);
}

function getPreparedCurrency(raw_currency = "") {
	const normalized_currency = String(raw_currency).trim().toUpperCase();

	switch (normalized_currency) {
		case "SSC":
			return "SC";
		case "GOC":
			return "GC";
		default:
			return raw_currency;
	}
}

function setFlashvars(params) {
	const device_type = ua.isDesktop ? 1 : 2; // 1 - desktop, 2 - mobile
	const amounts = params.amounts !== undefined ? params.amounts : "credits";
	const bet_list = getBetsList(params.game.source, params.bet_per_line, params.game.type, params.game.supp, params.ignore_allowed_bets);

	const currency = getPreparedCurrency(params.currency);

	window.flashvars = {
		device_type,
		bet_list,
		amounts,
		api: params.game.api,
		game_id: params.game_id,
		device_id: params.token,
		customer_id: params.billing,
		kf: params.kf,
		curr: currency,
		currency: currency,
		language: params.language,
		lang: params.language.substr(0, 2),
		bgcolor: params.bgcolor,
		home_page: decodeURIComponent(params.home_page),
		button: params.button,
		preloader_logo: 1,
		site_jackpot_api_url: params.extrasUrl,
		widescreen: params.widescreen,
		safe_value: params.safe_value,
		message: params.message
	};

	const additional_fields = [
		"idle_request_balance",
		"kf_list",
		"ot_autoopen",
		"ot_perone",
		"default_lines",
		"username"
	];

	const field_validators = {
		default_lines: isInt
	};

	additional_fields.forEach((field) => {
		if (params[field] !== undefined) {
			window.flashvars[field] = params[field];
		}
	});

	Object.entries(field_validators).forEach(([field, validator]) => {
		if (window.flashvars.hasOwnProperty(field)) {
			if (!validator(window.flashvars[field])) {
				logger.error(`Validation failed for field "${field}".`); // eslint-disable-line
				delete window.flashvars[field];
			}
		}
	});

	if (params.game.loader === "loader") {
		window.flashvars.url = params.path;
	}
}

function ignoreAllowedBetsBySource(source) {
	return source && IGNORE_ALLOWED_BETS_SOURCE.some((pattern) =>
		pattern === source || (pattern.endsWith("*") && source.startsWith(pattern.slice(0, -1))));
}

function getBetsList(source, bet_per_line = [], game_type = "slot", supp = 0, ignore_allowed_bets = false) {
	if (IGNORE_ALLOWED_BETS_SUPP.includes(supp) || ignore_allowed_bets || ignoreAllowedBetsBySource(String(source))) {
		return bet_per_line.slice().sort((a, b) => a - b);
	}

	if (game_type === "betting") {
		const sorted_bets = bet_per_line.sort((a, b) => a - b);
		const shrinked_bets = sorted_bets.slice(0, MAX_COUNT_ALLOWED_BETS);

		return shrinked_bets.map((bet) => bet * 100);
	}

	const filred_bets = bet_per_line.filter((bet) => ALLOWED_BETS.includes(bet));
	const sorted_bets = filred_bets.sort((a, b) => a - b);
	const shrinked_bets = sorted_bets.slice(0, MAX_COUNT_ALLOWED_BETS);

	return shrinked_bets;
}

function debug(str) {
	if (__DEV__) {
		const el = document.getElementById("debug");
		if (el) {
			el.style.display = "block";
			el.innerHTML = `${el.innerHTML}<span>${str}</span><br>`;
		}
	}
}

module.exports = {init, loadScript, addListener, parseQueryString, setFlashvars, debug, params};



// WEBPACK FOOTER //
// ./js/sys.js